export default __webpack_public_path__ + "bdd48f9e1e3f347c4e6f655c1fd13cb0.png";